import styles from './PromoSecondaryButton.module.scss';

interface IPromoSecondaryButtonProps {
  onClick?: () => void;
  /** @todo
   *
   * After deciding about `children` prop type (After 10.2025)
   * Please change the type or keep as is.
   * */
  children: string;
}

const PromoSecondaryButton = ({ onClick, children }: IPromoSecondaryButtonProps) => {
  return (
    <div onClick={onClick} className={`${styles.button} ${styles.button_secondary} d-fl ai-c jc-c`}>
      <p>{children}</p>
    </div>
  );
};

export default PromoSecondaryButton;
